'use client';

import { FunctionComponent } from 'react';
import { usePageViewAnalytics } from '../../../hooks/Analytics/usePageViewAnalytics';

export type CoursePageViewAnalyticsProps = {
    educatorId: string;
    courseId: string;
};

export const CoursePageViewAnalytics: FunctionComponent<CoursePageViewAnalyticsProps> = ({
    educatorId,
    courseId,
}) => {
    usePageViewAnalytics(async (analytics, pathname, url) => {
        await analytics.record.coursePageView(educatorId, courseId, pathname, url);
    });

    return null;
};
